import { render, staticRenderFns } from "./infoFormCoach.vue?vue&type=template&id=7b4ea9bc&scoped=true&"
import script from "./infoFormCoach.vue?vue&type=script&lang=js&"
export * from "./infoFormCoach.vue?vue&type=script&lang=js&"
import style0 from "./infoFormCoach.vue?vue&type=style&index=0&id=7b4ea9bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4ea9bc",
  null
  
)

component.options.__file = "infoFormCoach.vue"
export default component.exports